import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("rc_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const imgSrc = (u) => {
  if (!u) return "";
  if (u.startsWith("/api")) return `${BACKEND_URL}${u}`;
  return u;
};

export const AGENCY = {
  name: "ROMACASA",
  full: "ROMACASA Intermediazioni Immobiliari",
  phone: "+39 06 541 7973",
  phoneHref: "tel:+39065417973",
  whatsapp: "393939521037",
  email: "romacasa@romacasaweb.it",
  address: "Viale Europa 15, 00144 Roma",
  hours: "Lun – Ven 9:30 – 18:30 · Sab su appuntamento",
};

export const CATEGORIES = [
  { value: "appartamenti", label: "Appartamenti" },
  { value: "ville", label: "Ville" },
  { value: "prestigio", label: "Immobili di Prestigio" },
  { value: "commerciali", label: "Commerciali & Uffici" },
  { value: "cantieri", label: "Cantieri" },
];

export const CONTRACTS = [
  { value: "vendita", label: "In Vendita" },
  { value: "affitto", label: "In Affitto" },
];

export const categoryLabel = (v) => CATEGORIES.find((c) => c.value === v)?.label || v;
export const contractLabel = (v) => CONTRACTS.find((c) => c.value === v)?.label || v;

export const formatPrice = (p, lang = "it", showNumber = false) => {
  if (!p || p.contract === undefined) return "";
  if (p.price_on_request && !showNumber) {
    return lang === "en" ? "Price on request" : lang === "es" ? "Precio a consultar" : "Prezzo su richiesta";
  }
  const price = p.price;
  const formatted = `€ ${Number(price).toLocaleString("it-IT")}`;
  if (p.contract !== "affitto") return formatted;
  return lang === "en" ? `${formatted} / month` : lang === "es" ? `${formatted} / mes` : `${formatted} / mese`;
};

// Contenuti tradotti automaticamente: prende campo_en/es se esiste, altrimenti l'italiano
export const pickLang = (obj, field, lang) => (lang !== "it" && obj?.[`${field}_${lang}`]) || obj?.[field] || "";

export const waLink = (text) => `https://wa.me/${AGENCY.whatsapp}?text=${encodeURIComponent(text)}`;
